import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#000080",
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          backgroundColor: "transparent",
          "&:hover": {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
          "&:focus": {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
          "&:active": {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true, // disables ripple
        disableTouchRipple: true,
      },
    },
  },
});

export default theme;
